import { HEADER_BREAK_POINT, resetButton } from '../../styles/common';
export const style = {
    backButton: {
        ...resetButton,
        [HEADER_BREAK_POINT]: {
            color: 'primary.800'
        },
        color: 'neutral.0'
    }
};
